import { useState } from "react";
import { ChevronsLeftRight } from "lucide-react";

// Drag/slide to compare two photos of the same house (before = flooded, after = restored).
export default function BeforeAfterSlider({ before, after, beforeLabel = "Before", afterLabel = "After", beforeSub = "Emergency", afterSub = "Back home", className = "" }) {
  const [pos, setPos] = useState(50);

  return (
    <div className={`ba-slider ${className}`} style={{ "--ba": `${pos}%` }} data-testid="before-after-slider" data-position={Math.round(pos)}>
      <img src={after} alt={afterLabel} draggable={false} />
      <img src={before} alt={beforeLabel} className="ba-before" draggable={false} />
      <div className="ba-handle" aria-hidden>
        <span className="ba-knob"><ChevronsLeftRight className="w-6 h-6" /></span>
      </div>
      <span className="ba-label left-4" aria-hidden>{beforeLabel}<span className="hidden sm:inline"> · {beforeSub}</span></span>
      <span className="ba-label right-4" aria-hidden>{afterLabel}<span className="hidden sm:inline"> · {afterSub}</span></span>
      <input
        type="range"
        min={0}
        max={100}
        step={0.1}
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        aria-label="Compare before and after"
        className="ba-range"
        data-testid="before-after-range"
      />
    </div>
  );
}
